import React from 'react';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import ListYourItemsButton from '../ListYourItemsButton/ListYourItemsButton';
import css from './ImpactSection.module.css';

import impactImg from './pepala-causee-group.jpg';
import pepalaLogo from '../MoreCauses/pepala-logo.png';

// "The impact you create" — light band that shows the real-world result of a
// Causee sale, plus the "Join us for our launch" call to action. Replaces the
// old dark before/after block; layout, colours and spacing follow the design
// mockup (ui_kits/marketing-site/index.html, section .impact-light), rebuilt
// mobile-first with the site's Gilroy heading font.
const ImpactSection = () => {
  const intl = useIntl();

  return (
    <section className={css.section}>
      <div className={css.glow} aria-hidden="true" />

      <div className={css.inner}>
        <div className={css.topGrid}>
          <div className={css.copy}>
            <span className={css.eyebrow}>
              <FormattedMessage id="CustomLandingPage.impact.eyebrow" />
            </span>

            <h2 className={css.heading}>
              <FormattedMessage id="CustomLandingPage.impact.heading" />
            </h2>

            <p className={css.intro}>
              <FormattedMessage
                id="CustomLandingPage.impact.intro"
                values={{
                  partner: (
                    <span className={css.introHighlight}>
                      <FormattedMessage id="CustomLandingPage.impact.partnerName" />
                    </span>
                  ),
                }}
              />
            </p>
          </div>

          <figure className={css.figure}>
            <div className={css.frame}>
              <img
                className={css.photo}
                src={impactImg}
                alt={intl.formatMessage({ id: 'CustomLandingPage.impact.imageAlt' })}
                loading="lazy"
              />
            </div>
            <figcaption className={css.partnerChip}>
              <img
                className={css.partnerLogo}
                src={pepalaLogo}
                alt={intl.formatMessage({ id: 'CustomLandingPage.moreCauses.pepalaLogoAlt' })}
              />
              <span>
                <FormattedMessage id="CustomLandingPage.impact.partnerChip" />
              </span>
            </figcaption>
          </figure>
        </div>

        <div className={css.launchGrid}>
          <div className={css.launchAside}>
            <h3 className={css.launchHeading}>
              <FormattedMessage id="CustomLandingPage.impact.launchHeading" />
            </h3>
            <p className={css.question}>
              <FormattedMessage id="CustomLandingPage.impact.question" />
            </p>
            <ListYourItemsButton linkClassName={css.ctaLink} buttonClassName={css.cta}>
              <FormattedMessage id="CustomLandingPage.impact.cta" />
            </ListYourItemsButton>
          </div>

          <div className={css.launchBody}>
            <p className={css.body}>
              <FormattedMessage id="CustomLandingPage.impact.body1" />
            </p>
            <p className={css.body}>
              <FormattedMessage id="CustomLandingPage.impact.body2" />
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;
